export default "__VITE_ASSET__5a283b5b__"